import { Directive } from '@angular/core';
import { environment } from '@env/environment';
import { DefaultImageDirective } from '@shared/directives/default-image.directive';

@Directive({
  selector: '[appDefaultAvatar]',
  standalone: true,
})
export class DefaultAvatarDirective extends DefaultImageDirective {
  default = environment.wordpressJipImages + 'avatar-square.png';
}
